import { colors } from '@/styles';
import { StylesConfig } from 'react-select';

export const selectStyles: StylesConfig<any> = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? undefined
        : isSelected
          ? colors.semantic.selectOption.selected.background
          : isFocused
            ? colors.semantic.selectOption.focused.background
            : undefined,
      color: isDisabled
        ? colors.semantic.selectOption.disabled.color
        : isSelected
          ? colors.semantic.selectOption.selected.color
          : colors.semantic.selectOption.focused.color,
      cursor: isDisabled ? 'not-allowed' : 'default',
      fontWeight: isSelected ? 500 : undefined,

      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled
          ? isSelected
            ? colors.semantic.selectOption.selected.background
            : colors.semantic.selectOption.focused.background
          : undefined,
        color: !isDisabled
          ? isSelected
            ? colors.semantic.selectOption.selected.color
            : colors.semantic.selectOption.focused.color
          : undefined,
      },
    };
  },
};
